import React from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { useShortlist } from "../hooks/useShortlist";

// Floating "N saved" bar, shown whenever the shortlist is non-empty.
export function ShortlistBar() {
  const { count, clear } = useShortlist();

  return (
    <AnimatePresence>
      {count > 0 && (
        <motion.div
          initial={{ y: 80, opacity: 0, x: "-50%" }}
          animate={{ y: 0, opacity: 1, x: "-50%" }}
          exit={{ y: 80, opacity: 0, x: "-50%" }}
          transition={{ type: "spring", stiffness: 300, damping: 26 }}
          className="fixed bottom-5 left-1/2 z-40 flex items-center gap-4 rounded-full bg-[#14130F] py-2 pl-[1.1rem] pr-2 font-sans text-[0.9rem] text-[#F4F2ED] shadow-[0_8px_30px_rgba(20,19,15,0.3)]"
        >
          <span>
            <span className="font-bold">{count}</span> saved
          </span>
          <Link
            to="/properties?saved=1"
            className="rounded-full bg-[#B7975A] px-[0.95rem] py-[0.45rem] font-semibold text-[#14130F] no-underline"
          >
            View shortlist
          </Link>
          <button type="button" onClick={clear} className="text-[0.85rem] text-[#C9C3B4] hover:text-white">
            Clear
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
